import { FC, memo } from 'react';

import IconCreditCardFilled from '@zvuk-b2b/react-uikit/ui/icons/CreditCardFilled';

import { TEXTS } from './texts';

import styles from './index.module.scss';

const CardEmpty: FC = () => (
  <div className={styles.cardEmpty}>
    <IconCreditCardFilled className={styles.icon} />
    <div className={styles.text}>{TEXTS.EMPTY_CARD_TEXT}</div>
  </div>
);

export default memo(CardEmpty);
